const TrustLeaderComponent = () => {
  return (
    <div
      className=" flex flex-col justify-center px-[2rem] py-[2rem] lg:px-[7rem] lg:py-[4rem] md:p-[4rem]"
      style={{ backgroundImage: "url(/Home/TrustALeaderBG.png)" }}
    >
      <div className="mx-auto xl:width-[70rem] !important]">
        <div className="grid justify-center">
          <h1 className="react-reveal font-bold text-4xl text-[#373737]">
            At a Glance
          </h1>
          <hr className="react-reveal hr-glance flex justify-center" />
        </div>
        <div className="flex justify-between items-center mt-[1rem] xl:w-[60rem] lg:w-[50rem] md:w-[38rem]">
          <div className="react-reveal flex-1 lg:w-[50rem] md:w-[35rem]  pt-[1rem] cursor-pointer ">
            <img
              src="/Home/At_glance.jpg"
              alt=""
              className="hidden md:block border-4 "
            />
            <img
              src="/Home/glance-mobile2.jpg"
              alt=""
              className="md:hidden block "
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustLeaderComponent;
